import CampaignListPanel from "./campaignListPanel.container"

export default CampaignListPanel
